import React from 'react';
import { Form, Input, Button,Spin,Select } from 'antd';
import axios from 'axios'
import * as serverconfig from '../../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;

var token= ''
var sacco= ''

class UgDistrictForm extends React.Component {

  state = {
    district_name:'' ,  
    region:'',
    datarequested:true,
    regions:[]
  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/regions`)
    .then(res => {
        this.setState({
            regions:res.data
        })
        this.setState({datarequested:false})

    })


  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('district_name', this.state.district_name);
    form_data.append('region', this.state.region);

      axios.post(serverconfig.backendserverurl+'/api/districts/', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res =>     this.setState({datarequested:false})
    , window.location.reload(false)
    )
    .catch(error => console.log(error))

  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >
      <FormItem label="District Name"
        name="district_name"
        rules={[
          {
            required: true,
            message: 'Please input name',
          },
        ]}
      >
        <Input name="district_name"  placeholder="Put a name here." value={this.state.district_name} onChange={(val)=>{this.setState({district_name:val.target.value})}} />
      </FormItem>


      <FormItem label="Region">
          <Select placeholder="Region" 
          value={this.state.region}
          onChange={(val)=>{this.setState({region:val})}} 
          showSearch
          optionFilterProp="children"
          >
            {this.state.regions.map(
              (itm)=>(
                <Option value={itm.name}>{itm.name}</Option>
              ))}
          </Select>
      </FormItem>

     
      <FormItem>
        <Button  type="primary" htmlType="submit">Create</Button>
      </FormItem>
       </Form>
        </div>
      );

    }

   
  }

}


export default UgDistrictForm;



